import { createSlice } from '@reduxjs/toolkit'

export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    value: false
  },
  reducers: {
    updateLogin: (state, action) => {
      state.value = action.payload;
    }
  }
})

export const { updateLogin } = loginSlice.actions

export const selectLogin = (state) => state.login.value

export default loginSlice.reducer